/* eslint-disable import/prefer-default-export */
// TODO: Add pharmacy ids for all locations
export const LEAD_LOCATIONS = [
  { id: '1', name: 'St. Catharines Pharmacy' },
  { id: '2', name: 'Niagara Falls Pharmacy' },
  { id: 'Y9fQxebL405BUpapMONw', name: 'Grove St. Pharmacy' },
];
